import axios from 'axios'

export const all = (params: any = {}): Promise<any> => {
  return axios.get('/degrees', {
    params,
  })
}
